export function isTableOpsRoleScopedUser(user: any): boolean {
  const roles: unknown[] = Array.isArray(user?.roles) ? user.roles : [];
  const normalized = roles
    .map((r: unknown) => String(r || '').trim().toLowerCase())
    .filter(Boolean);

  if (normalized.length === 0) return false;
  if (normalized.includes('superadmin') || normalized.includes('super_admin')) return false;

  return normalized.every((r) => r.startsWith('tableops.'));
}